export default __webpack_public_path__ + "assets/images/f5eccf586451d9abb0c78660bb278529.png";